import { jsx as _jsx } from "react/jsx-runtime";
import { useStyleConfig, vui } from '../core';
import { T } from '../t';
import { cs } from '../utils';
import { useListContext } from './context';
/** Displays a heading within the List. */
export const ListHeading = vui((props, ref) => {
    const { className, ...rest } = props;
    const styles = useStyleConfig('List', useListContext());
    return (_jsx("li", { children: _jsx(T, { className: cs('vui-listHeading', className), display: "inline-block", px: 2, py: 1, ref: ref, size: "sm", textTransform: "uppercase", weight: "medium", ...styles.heading, ...rest }) }));
});
ListHeading.displayName = 'ListHeading';
export default ListHeading;
